import React, { Component, Suspense, lazy, useEffect, useMemo, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Cookies from "js-cookie";
import "react-datepicker/dist/react-datepicker.css";

import $ from "jquery";
import LoadingScreen from "./LoadingScreen";

import Sidebar from "./Sidebar/SidebarMenu.jsx";
import { useDispatch } from "react-redux";
import { setExpandSidebar } from "../store/slices/sidebarSlice.js";
import { useFirebasePageTracking } from "../hooks/useFirebasePageTracking.js";
import {
  getEnvVersion,
  clearLocalStoragePreserveEssentials,
  checkAndHandleEnvChange,
  decryptData
} from "../utility/util.js";
import semver from "semver";

const LoginPage = lazy(() => lazyRetry(() => import("./loginpage"), "LoginPage"));
const LoginOIDC = lazy(() => lazyRetry(() => import("./LoginOIDC.jsx"), "LoginOIDC"));
const HenngeDirectLogin = lazy(() =>
  lazyRetry(() => import("./HenngeDirectLogin.jsx"), "HenngeDirectLogin")
);
const ChangePasswordOIDC = lazy(() =>
  lazyRetry(() => import("./ChangePasswordOIDC.jsx"), "ChangePasswordOIDC")
);
const SwitchRoleSuccessOIDC = lazy(() =>
  lazyRetry(() => import("./SwitchRoleSuccessOIDC.jsx"), "SwitchRoleSuccessOIDC")
);
const SwitchRoleFailOIDC = lazy(() =>
  lazyRetry(() => import("./SwitchRoleFailOIDC.jsx"), "SwitchRoleFailOIDC")
);
const Dashboard = lazy(() => lazyRetry(() => import("../MainPage/Main/Dashboard"), "Dashboard"));
const Administrator = lazy(() =>
  lazyRetry(() => import("../MainPage/Administration"), "Administrator")
);
const HR = lazy(() => lazyRetry(() => import("../MainPage/HR"), "HR"));
const Reports = lazy(() => lazyRetry(() => import("../MainPage/HR/Reports"), "Reports"));
const Payroll = lazy(() => lazyRetry(() => import("../MainPage/HR/Payroll"), "Payroll"));
const MP = lazy(() => lazyRetry(() => import("../MainPage/HR/masterPayroll"), "MP"));
const Master = lazy(() => lazyRetry(() => import("../MainPage/HRMS/masterData"), "Master"));
const Kankei = lazy(() => lazyRetry(() => import("../MainPage/kankei"), "Kankei"));
const Organization = lazy(() =>
  lazyRetry(() => import("../MainPage/HRMS/organization"), "Organization")
);
const Setup = lazy(() => lazyRetry(() => import("../MainPage/HRMS/setup"), "Setup"));
const globalSetup = lazy(() =>
  lazyRetry(() => import("../MainPage/HRMS/globalSetup"), "globalSetup")
);
const AdvancedQuery = lazy(() =>
  lazyRetry(() => import("../MainPage/HRMS/advancedquery"), "AdvancedQuery")
);
const criteriaQuery = lazy(() =>
  lazyRetry(() => import("../MainPage/HRMS/criteriaquery"), "criteriaQuery")
);
const dataPolicy = lazy(() => lazyRetry(() => import("../MainPage/HRMS/datapolicy"), "dataPolicy"));
const recipientlogic = lazy(() =>
  lazyRetry(() => import("../MainPage/HRMS/recipientlogic"), "recipientlogic")
);
const query = lazy(() => lazyRetry(() => import("../MainPage/HRMS/query"), "query"));
const Learning = lazy(() => lazyRetry(() => import("../MainPage/learning"), "Learning"));
const Worker = lazy(() => lazyRetry(() => import("../MainPage/Worker"), "Worker"));
const Recruitment = lazy(() => lazyRetry(() => import("../MainPage/recruitment"), "Recruitment"));
const Profile = lazy(() => lazyRetry(() => import("../MainPage/Profile"), "Profile"));
const Action = lazy(() =>
  lazyRetry(() => import("../MainPage/Administration/Settings/action"), "Action")
);
const Themesettings = lazy(() =>
  lazyRetry(() => import("../MainPage/Administration/Settings/themesetting"), "Themesettings")
);
const MenuSettings = lazy(() =>
  lazyRetry(() => import("../MainPage/Administration/Settings/MenuSettings"), "MenuSettings")
);
const Benefit = lazy(() => lazyRetry(() => import("../MainPage/HRMS/benefit"), "Benefit"));
const UserDefined = lazy(() =>
  lazyRetry(() => import("../MainPage/Custom/user-defined"), "UserDefined")
);
const InternalMemo = lazy(() =>
  lazyRetry(() => import("../MainPage/Custom/internal-memo"), "InternalMemo")
);
const Performance = lazy(() => lazyRetry(() => import("../MainPage/performance"), "Performance"));

const AttendanceOvertime = lazy(() =>
  lazyRetry(() => import("./AttendanceOvertime"), "AttendanceOvertime")
);
const ShowAttendance = lazy(() => lazyRetry(() => import("./ShowAttendance"), "ShowAttendance"));
const ShowOvertime = lazy(() => lazyRetry(() => import("./ShowOvertime"), "ShowOvertime"));
const ShowOvertimeDetail = lazy(() =>
  lazyRetry(() => import("./ShowOvertimeDetail"), "ShowOvertimeDetail")
);
const LoginAAD = lazy(() => lazyRetry(() => import("./LoginAAD"), "LoginAAD"));
const Approvaldocument = lazy(() => lazyRetry(() => import("./CustomPage/Approvaldocument"), "Approvaldocument"));
const ForgotPassword = lazy(() => lazyRetry(() => import("./forgotpassword"), "ForgotPassword"));

const Error404 = lazy(() =>
  lazyRetry(() => import("../MainPage/Pages/ErrorPage/error404"), "Error404")
);
const Error500 = lazy(() =>
  lazyRetry(() => import("../MainPage/Pages/ErrorPage/error500"), "Error500")
);
const PageTest = lazy(() =>
  lazyRetry(() => import("../MainPage/Pages/ErrorPage/pageTest.jsx"), "PageTest")
);
const AttendanceDetailGrid = lazy(() =>
  lazyRetry(
    () => import("../MainPage/kankei/attendance-report/AttendanceDetailGrid.jsx"),
    "AttendanceDetailGrid"
  )
);
const PageNotFound = lazy(() => lazyRetry(() => import("./PageNotFound"), "PageNotFound"));
const DoNotHavePermission = lazy(() =>
  lazyRetry(() => import("./DoNotHavePermission"), "DoNotHavePermission")
);
const AuthenticationError = lazy(() =>
  lazyRetry(
    () => import("../MainPage/Pages/ErrorPage/AuthenticationError.jsx"),
    "AuthenticationError"
  )
);

const Footer = lazy(() => lazyRetry(() => import("./Sidebar/Footer"), "Footer"));
const Header = lazy(() => lazyRetry(() => import("./Sidebar/header.jsx"), "Header"));

const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
};

const collectSystemObjectIDs = (menuItem) => {
  if (!menuItem || !menuItem.systemObjectID) return [];

  let menuId = [menuItem.systemObjectID];

  if (Array.isArray(menuItem.children)) {
    menuItem.children.forEach((child) => {
      menuId = menuId.concat(collectSystemObjectIDs(child));
    });
  }

  return menuId;
};

const _getMenuSetup = async (tempObjectSystem) => {
  const filterObjectSystemSetup = tempObjectSystem.filter((menu) => menu.types === "Setup");

  let menuIds = [];

  filterObjectSystemSetup.forEach((matchedMenu) => {
    menuIds = menuIds.concat(collectSystemObjectIDs(matchedMenu));
  });

  return [...new Set(menuIds)];
};

const RouteConfig = ({ component: Component, fullLayout, nosidebar, ...rest }) => {
  const currentUrl = window.location.href;

  const urlObj = new URL(currentUrl);

  const params = new URLSearchParams(urlObj.search);

  const selfPage = params.get("self-page");

  const isOnePage = selfPage ? decryptData(selfPage) === "true_super" : false;

  const tempObjectSystem = useMemo(() => {
    return JSON.parse(localStorage.getItem("objectSystem") || "[]");
  }, []);

  const filterObjectSystem = useMemo(() => {
    return tempObjectSystem
      .filter((menu) => menu.types === "Setup" || menu.types === "Menu")
      .map((menu) => ({
        description: menu.headerTitle,
        iconpath: menu.icon,
        label: menu.headerTitle,
        title: menu.headerTitle,
        value: menu.headerTitle,
        systemObjectID: menu.systemObjectID,
        types: menu.types,
        uri: menu.uri,
        addinfo: menu.order,
        children: menu.children,
      }));
  }, [tempObjectSystem]);

  const width = useWindowWidth();
  const dispatch = useDispatch();
  const [menuSetupIds, setMenuSetupIds] = useState([]);

  const allMenuIds = useMemo(() => {
    let ids = [];
    filterObjectSystem.forEach((matchedMenu) => {
      ids = ids.concat(collectSystemObjectIDs(matchedMenu));
    });
    return [...new Set(ids)];
  }, [filterObjectSystem]);

  let isMenuSetting = false;

  const currentPath = window.location.pathname;
  isMenuSetting =
    currentPath.includes("menu-settings") || menuSetupIds.some((id) => currentPath.includes(id));

  const menuId = useMemo(() => {
    return allMenuIds.find((id) => currentPath.includes(id));
  }, [allMenuIds, currentPath]);

  const detailMenu = useMemo(() => {
    return tempObjectSystem.find((menu) => menu.systemObjectID === menuId);
  }, [tempObjectSystem, menuId]);

  useFirebasePageTracking(detailMenu?.name); // For Web Analytic

  useEffect(() => {
    const fetchMenuIds = async () => {
      const idsSetup = await _getMenuSetup(filterObjectSystem);

      setMenuSetupIds(idsSetup);
    };

    fetchMenuIds();
  }, [filterObjectSystem]);

  const renderComponent = (props) => {
    // ── Email approval navigation restriction ────────────────────────────────
    // If the user arrived via an email approval link, only /approvaldocument and
    // the one specific approval page they were directed to are accessible.
    // Any other navigation attempt clears the session and redirects to login.
    const isEmailApprovalMode = sessionStorage.getItem("emailApprovalMode") === "true";
    if (isEmailApprovalMode) {
      const emailApprovalAllowedPath = sessionStorage.getItem("emailApprovalAllowedPath") || "";
      const isApprovalDocPage = currentPath === "/approvaldocument";
      const isAllowedPath =
        emailApprovalAllowedPath && currentPath.startsWith(emailApprovalAllowedPath);
      if (!isApprovalDocPage && !isAllowedPath) {
        clearLocalStoragePreserveEssentials();
        sessionStorage.removeItem("emailApprovalMode");
        sessionStorage.removeItem("emailApprovalAllowedPath");
        return <Redirect to="/login" />;
      }
    }
    // ────────────────────────────────────────────────────────────────────────

    if (fullLayout || isOnePage) {
      return (
        <div className="full-layout">
          <Component {...props} />
        </div>
      );
    } else if (nosidebar) {
      return (
        <Suspense fallback={<LoadingScreen />}>
          <section>
            <Component {...props} />
          </section>
        </Suspense>
      );
    } else {
      return (
        <>
          <div className="main-wrapper">
            <Suspense fallback={<LoadingScreen />}>
              <section>
                <Header />
                <div
                  onMouseEnter={() =>
                    dispatch(
                      setExpandSidebar({
                        isExpandSidebar: false,
                      })
                    )
                  }
                >
                  <Component {...props} />
                </div>

                <Footer />

                {width > 991 && (
                  <Sidebar variant="desktop" typesMenu={isMenuSetting ? "Setup" : "Module"} />
                )}
                {width <= 991 && (
                  <Sidebar variant="mobile" typesMenu={isMenuSetting ? "Setup" : "Module"} />
                )}
                {/* <SidebarContent /> */}
              </section>
            </Suspense>
          </div>
        </>
      );
    }
  };

  return (
    <Route
      {...rest}
      render={renderComponent}
    />
  );
};

const lazyRetry = function (componentImport, name) {
  return new Promise((resolve, reject) => {
    // check if the window has already been refreshed
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem(`retry-${name}-refreshed`) || "false"
    );
    // try to import the component
    componentImport()
      .then((component) => {
        window.sessionStorage.setItem(`retry-${name}-refreshed`, "false"); // success so reset the refresh
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          // not been refreshed yet
          window.sessionStorage.setItem(`retry-${name}-refreshed`, "true"); // we are now going to refresh
          return window.location.reload(); // refresh the page
        }
        reject(error); // Default error behaviour as already tried refresh
      });
  });
};

const AppRoute = RouteConfig;
export default class App extends Component {
  componentDidMount() {
    const envVersion = getEnvVersion();

    // Detect version change and clear stale cache.
    // Skip on auth-related paths to avoid interrupting the Identity Server PKCE flow.
    // Clearing localStorage during /signin-oidc would wipe pkce_code_verifier,
    // and reloading would re-submit the single-use OAuth code → exchange failure → login loop.
    const isAuthPath = ["/signin-oidc", "/login", "/authentication-error"].some((p) =>
      window.location.pathname.includes(p)
    );
    if (!isAuthPath) {
      checkAndHandleEnvChange();
    }

    this.handleBackground();
    this.handleColor();

    if (
      window.location.pathname.includes("login") ||
      window.location.pathname.includes("signin") ||
      window.location.pathname.includes("register") ||
      window.location.pathname.includes("forgotpassword") ||
      window.location.pathname.includes("otp") ||
      window.location.pathname.includes("lockscreen")
    ) {
      $("body").addClass("account-page");
    } else if (
      window.location.pathname.includes("403") ||
      window.location.pathname.includes("404") ||
      window.location.pathname.includes("error-404") ||
      window.location.pathname.includes("error-500")
    ) {
      $("body").addClass("error-page");
    } else if (
      window.location.pathname.includes("self-presence") ||
      window.location.pathname.includes("show-overtime") ||
      window.location.pathname.includes("overtime-detail") ||
      window.location.pathname.includes("attendance")
    ) {
      $("body").addClass("page-custom");
    }
    // this.checkVersion();
    localStorage.setItem("versionsapp", envVersion);

    if (
      window.location.pathname !== "/" &&
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/signin-oidc" &&
      window.location.pathname !== "/authentication-error" &&
      window.location.pathname !== "/signin-hennge"
    ) {
      Cookies.set("redirectFromEmail", window.location.pathname, {
        expires: 1,
        secure: true,
        sameSite: "lax",
      });
    }
  }

  setExpired = () => {
    var now = new Date();
    var time = now.getTime();
    var expireTime = time + 5 * 36000;
    var d = new Date(expireTime);
    let text = d.toUTCString();
    return text;
  };

  checkVersion = () => {
    const currentVersion = localStorage.getItem("versionsapp");
    const envVersion = getEnvVersion();

    const clearCacheAndStorage = async () => {
      if ("caches" in window) {
        try {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map((name) => caches.delete(name)));
        } catch (err) {
          console.error("Error clearing caches:", err);
        }
      }

      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const reg of registrations) await reg.unregister();
      }

      clearLocalStoragePreserveEssentials();
    };

    const handleVersionMismatch = async () => {
      alert("New app update is available! Please relogin.");
      await clearCacheAndStorage();
      window.location.href = "/login";
    };

    const handleFirstTimeVisit = async () => {
      if (
        ["/", "/login", "/signin-oidc", "/authentication-error"].includes(window.location.pathname)
      ) {
        await clearCacheAndStorage();
        localStorage.setItem("versionsapp", envVersion);
      } else {
        await handleVersionMismatch();
      }
    };

    // eslint-disable-next-line no-console
    console.info("Check Version Match: ", currentVersion, envVersion);

    if (currentVersion) {
      if (semver.neq(currentVersion, envVersion)) {
        handleVersionMismatch();
      }
    } else {
      handleFirstTimeVisit();
    }
  };

  handleColor = () => {
    let colorSelect = "#0273BB";

    if (localStorage.getItem("tenantTheme")) {
      colorSelect = localStorage.getItem("tenantTheme");
    }

    if (localStorage.getItem("themeColor")) {
      colorSelect = localStorage.getItem("themeColor");
    }

    document.documentElement.style.setProperty("--primary-color", colorSelect);
  };

  handleBackground = async () => {
    const tenantImage = localStorage.getItem("tenantImage");
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundRepeat = "no-repeat";

    if (tenantImage) {
      document.body.style.backgroundImage = `url('${tenantImage}')`;
    } else {
      document.body.style.backgroundImage = `url("/assets/img/backgroundCloud.png")`;
    }
  };

  render() {
    return (
      <div>
        <Suspense fallback={<LoadingScreen />}>
          <Switch>
            {/* //fullLayout */}
            <AppRoute exact path="/" component={() => <Redirect to="/login" />} />
            {/* <AppRoute path="/inout" component={LoginPage} fullLayout /> */}
            <AppRoute path="/login" component={LoginPage} fullLayout />
            <AppRoute path="/signin-oidc" component={LoginOIDC} fullLayout />
            <AppRoute path="/signin-hennge" component={HenngeDirectLogin} fullLayout />
            <AppRoute path="/change-password-success" component={ChangePasswordOIDC} fullLayout />
            <AppRoute path="/switch-role-success" component={SwitchRoleSuccessOIDC} fullLayout />
            <AppRoute path="/switch-role-fail" component={SwitchRoleFailOIDC} fullLayout />
            <AppRoute path="/authad" component={LoginAAD} fullLayout />
            <AppRoute path="/forgotpassword" component={ForgotPassword} fullLayout />
            <AppRoute path="/self-presence" component={AttendanceOvertime} nosidebar />
            {/* <AppRoute path="/attendance" component={AttendanceOvertime} fullLayout /> */}
            <AppRoute path="/show-attendance" component={ShowAttendance} nosidebar />
            <AppRoute path="/show-overtime" component={ShowOvertime} nosidebar />
            <AppRoute path="/overtime-detail/:id" component={ShowOvertimeDetail} nosidebar />
            <AppRoute path="/error-404" component={Error404} fullLayout />
            <AppRoute path="/error-500" component={Error500} fullLayout />
            <AppRoute path="/page-test" component={PageTest} />
            {/* Direct route, same pattern as /page-test -- arketipe D isn't wired into the
                DB-driven menu/system-object tab system TimeAttendanceReport.jsx uses (that
                needs a menu-line row on the backend, out of reach from code alone); reachable
                here until that's set up. */}
            <AppRoute path="/attendance-detail-grid" component={AttendanceDetailGrid} />
            <AppRoute path="/404" component={PageNotFound} fullLayout />
            <AppRoute path="/403" component={DoNotHavePermission} fullLayout />
            <AppRoute path="/authentication-error" component={AuthenticationError} fullLayout />
            <AppRoute path="/approvaldocument" component={Approvaldocument} fullLayout />

            {/* //split */}
            {/* <AppRoute path="/app" component={DefaultLayout} /> */}
            <AppRoute path="/app/main" component={Dashboard} />
            <AppRoute path="/app/theme-settings" component={Themesettings} />
            <AppRoute path="/app/menu-settings" component={MenuSettings} />
            <AppRoute path="/app/benefit" component={Benefit} />
            <AppRoute path="/app/worker" component={Worker} />
            <AppRoute path="/app/recruitment" component={Recruitment} />
            <AppRoute path="/app/profile" component={Profile} />
            <AppRoute path="/app/action" component={Action} />
            <AppRoute path="/app/organization" component={Organization} />
            <AppRoute path="/app/setup" component={Setup} />
            <AppRoute path="/app/globalSetup" component={globalSetup} />
            <AppRoute path="/app/AdvancedQuery" component={AdvancedQuery} />
            <AppRoute path="/app/criteriaQuery" component={criteriaQuery} />
            <AppRoute path="/app/dataPolicy" component={dataPolicy} />
            <AppRoute path="/app/recipientlogic" component={recipientlogic} />
            <AppRoute path="/app/query" component={query} />
            <AppRoute path="/app/master" component={Master} />
            <AppRoute path="/app/kankei" component={Kankei} />
            <AppRoute path="/app/administrator" component={Administrator} />
            <AppRoute path="/app/performance" component={Performance} />
            <AppRoute path="/app/hr" component={HR} />
            <AppRoute path="/app/reports" component={Reports} />
            <AppRoute path="/app/payroll" component={Payroll} />
            <AppRoute path="/app/user-defined" component={UserDefined} />
            <AppRoute path="/app/internal-memo" component={InternalMemo} />
            <AppRoute path="/app/masterPayroll" component={MP} />
            <AppRoute path="/app/learning" component={Learning} />
            <AppRoute path="*" exact={true} component={PageNotFound} fullLayout />
          </Switch>
        </Suspense>
      </div>
    );
  }
}
